import { AService, Params } from "./Service";

type IYandexMetricFunction = (counterId: number | string, method: string, ...args: unknown[]) => void;

declare global {
    interface Window {
        ym?: IYandexMetricFunction,
        ymCounterId?: number
    }
}

class YandexMetricService extends AService {
    public readonly serviceName = 'ya-metrics';

    protected getId = () => window.ymCounterId;

    protected getLogFunc = () => window.ym;

    protected sendGoalEvent(eventId: string, params: Params) {
        this.sendEvent(this.getId(), 'reachGoal', eventId, params);
    }
}

export const yandexMetricService = new YandexMetricService();
